import React from 'react'
import { Box, Grid, Typography } from '@mui/material'

import Form from './Form'

import config       from '../../../static/Inicio'
import { Formik }   from 'formik'
import initialState from './config'
import { schema }   from './schema'

const name = process.env.REACT_APP_BUSINESS_NAME  

const Cpf = () => {

    return (
        <Formik 
            initialValues={initialState}
            validationSchema={schema}
            enableReinitialize={true}     
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
            >   
                <Typography variant="h3" 
                    spacing={4} 
                    component="h3"
                    mt={2} 
                >{config.title} {name}</Typography>
                <Grid container spacing={2} py={2}>
                    <Form />
                    {/* {!hasUser && <Cadastro />} */}
                </Grid>
            </Box>
        </Formik>
    )
}

export default Cpf